
























































































































































































































































import Vue from "vue";
import Page from "@/components/Page.vue";

// import Istore, {InterfaceStore} from "../services/InterfaceStore";
import NavigationButton from "@/components/NavigationButton.vue";
import ButtonCheckBox from "@/components/ButtonCheckBox.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateTimeInput from "../../../components/DateTimeInput.vue";
import DateInput from "../../../components/DateInput.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";


// import store, { CashFlowStore } from "@/modules/cashFlowRiport/services/CashFlowStore";
import eventBus from "@/services/eventBus";
import GlobalStore from "@/models/GlobalStore";
import IconButton from "@/components/IconButton.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import CarRequestTool from "./requestTools/CarRequestTool.vue";
import PartnerRequestTool from "./requestTools/PartnerRequestTool.vue";
import InvoiceRequestTool from "./requestTools/InvoiceRequestTool.vue";
import store, { InterfaceStore } from "../services/InterfaceStore";
import { IfaceType } from "../models/IfaceType";
import { IfaceFeature } from "../models/IfaceSyncFeature";
import { Confirmation } from "@/components/ConfirmationBox.vue";
import { t } from "@/plugins/i18n";




enum ConfirmType {
  None = 0,
  ReSyncSelectedItems = 1,
  ReSyncInterface = 2,
  MarkSelectedItemsSkipped = 3,
  SetRemarkOnSelectedItems = 4,
  /** lout_interface: betöltés a köztes táblába a toolbar intervallumára (az IfaceSync API load végpontja) */
  UpSyncLoadInterface = 5,
  /** push_select_items: a kijelölt köztes sorok feltöltése az interfészre (az IfaceSync API sync végpontja) */
  UpSyncSelectedItems = 6,
  /** lout_select_items: a kijelölt köztes sorok rekordjainak újra betöltése a köztes táblába (load végpont, azonosítókkal) */
  UpSyncReloadSelectedItems = 7,
}

/** Egy rssysisyncfeature flaghez tartozó toolbar gomb */
interface FeatureButton {
  feature: IfaceFeature;
  icon: string;
  tooltip: string;
  /** Megerősítés után futó művelet */
  confirm?: ConfirmType;
  /** Az összeállított lekérdezés panelt nyitja/zárja */
  requestTool?: boolean;
}

/** Feliratos gombcsoport a toolbarban */
interface FeatureGroup {
  caption: string;
  buttons: FeatureButton[];
}

/**
 * A szinkron gombok csoportjai a flagek oszlopsorrendjében. Ahol se `confirm`, se `requestTool` nincs,
 * a funkció még nincs bekötve — a gomb a flag alapján megjelenik, kattintásra figyelmeztetést ad.
 */
const featureGroups: FeatureGroup[] = [
  {
    caption: "Lekérés funkciók",
    buttons: [
      { feature: IfaceFeature.DsyncSelectItems, icon: "fa-arrow-circle-o-down", tooltip: "Kijelölt tételek szinkronizálása", confirm: ConfirmType.ReSyncSelectedItems },
      { feature: IfaceFeature.DsyncInterface, icon: "fa-arrow-down", tooltip: "Interfész szinkronizálása a megadott intervallumra", confirm: ConfirmType.ReSyncInterface },
      { feature: IfaceFeature.DsyncSendRequest, icon: "fa-external-link", tooltip: "Lekérdezés indítása az interfészre", requestTool: true },
      { feature: IfaceFeature.DsyncFromFile, icon: "fa-upload", tooltip: "Beolvasás fájlból", requestTool: true },
      { feature: IfaceFeature.FetchSelectItems, icon: "fa-cloud-download", tooltip: "Kijelölt tételek letöltése az interfészről (csak a köztes tábláig)" },
      { feature: IfaceFeature.FetchInterface, icon: "fa-calendar", tooltip: "Intervallumos lekérés az interfészről (csak a köztes tábláig)" },
      { feature: IfaceFeature.FetchSendRequest, icon: "fa-filter", tooltip: "Összeállított lekérés az interfészről (csak a köztes tábláig)" },
      { feature: IfaceFeature.LinSelectItems, icon: "fa-sign-in", tooltip: "Kijelölt tételek betöltése a köztes táblából" },
      { feature: IfaceFeature.LinInterface, icon: "fa-inbox", tooltip: "Minden feldolgozásra váró tétel betöltése a köztes táblából" },
    ],
  },
  {
    caption: "Feltöltés funkciók",
    buttons: [
      { feature: IfaceFeature.UsyncSelectItems, icon: "fa-cloud-upload", tooltip: "Teljes szinkronizáció a kijelölt tételekre" },
      { feature: IfaceFeature.UsyncInterface, icon: "fa-arrow-up", tooltip: "Adatok szinkronizálása az interfészre a megadott időintervallumra" },
      { feature: IfaceFeature.UsyncSendRequest, icon: "fa-external-link", tooltip: "Teljes szinkronizáció összeállított lekérdezéssel" },
      { feature: IfaceFeature.PushSelectItems, icon: "fa-arrow-circle-o-up", tooltip: "Kijelölt tételek szinkronizálása", confirm: ConfirmType.UpSyncSelectedItems },
      { feature: IfaceFeature.PushInterface, icon: "fa-paper-plane-o", tooltip: "Minden feldolgozásra váró tétel felküldése az interfészre" },
      { feature: IfaceFeature.LoutSelectItems, icon: "fa-refresh", tooltip: "Kijelölt tételek újra betöltése a köztes táblába", confirm: ConfirmType.UpSyncReloadSelectedItems },
      { feature: IfaceFeature.LoutInterface, icon: "fa-download", tooltip: "Betöltés a köztes táblába a megadott intervallumra", confirm: ConfirmType.UpSyncLoadInterface },
      { feature: IfaceFeature.LoutSendRequest, icon: "fa-external-link", tooltip: "Betöltés a köztes táblába összeállított lekérés alapján", requestTool: true },
    ],
  },
];

interface Data {
  store: InterfaceStore;
  showRemarkField: boolean;
  showConfirm: boolean;
  confirmType: number;
  remarkText: string;
  IfaceType: typeof IfaceType;

}

interface Methods {
  reload(): void;
  /** Ugrás a rendszerparaméterek Külső interfészek kártyájára. */
  openInterfaceParameters(): void;
  handleShowRequestTool(): void;
  handleShowConfirm(type: ConfirmType): void;
  sendRequest(): Promise<void>;
  runFeature(button: FeatureButton): void;
}

interface Computed {
  /** A kiválasztott interfészen és típuson engedélyezett gombok csoportonként — üres csoport nélkül */
  visibleFeatureGroups: FeatureGroup[];
  /** A toolbar dátum-intervallum jelentése az aktuális interfész típuson. */
  dateFilterTooltip: string;
}

interface Props {
  /** Előzmény mód — ilyenkor csak a szűrők jelennek meg, szinkron funkció gombok nem. */
  historyMode: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    historyMode: { type: Boolean, default: false },
  },

  components: {
    NavigationButton,
    // ButtonCheckBox,
    CheckBox,
    // DateInput,
    // DateTimeInput,
    DateInput,
    // IconButton
    CarRequestTool,
    PartnerRequestTool,
    InvoiceRequestTool,
  },

  data() {
    return {
      store,
      showRemarkField: false,
      showConfirm: false,
      confirmType: 0,
      remarkText: "",
      ConfirmType,
      IfaceType,

    };
  },

  async beforeMount() {
    this.store.loadSyncStatuses();
    await this.store.loadInterfaces();
    await this.store.loadFeatures();
    await this.store.loadInterfaceTypes();
  },

  watch: {
    /** Interfész váltáskor a hozzá tartozó feature sorok (láthatóság + funkciók) újratöltése */
    "store.selectedInterface": {
      async handler() {
        await this.store.loadInterfaceTypes();
      },
    },
  },

  computed: {
    dateFilterTooltip() {
      const isInvoice = this.store.selectedInterfaceType === IfaceType.InInvoice
        || this.store.selectedInterfaceType === IfaceType.OutInvoice;
      return isInvoice
        ? t("Interface_SzamlaKiallitasDatumaListaSzuresEs")
        : t("Interface_UtolsoSzinkronDatumaListaSzuresSzinkron");
    },

    visibleFeatureGroups() {
      return featureGroups
        .map((group) => ({ ...group, buttons: group.buttons.filter((b) => this.store.hasFeature(b.feature)) }))
        .filter((group) => group.buttons.length > 0);
    },
  },

  methods: {
    /** Mindkét apisearch újratöltése. */
    reload() {
      eventBus.$emit("refreshSyncList");
      eventBus.$emit("refreshSyncErrorList");
    },

    /** A rendszerparaméterek oldal a query alapján a Külső interfészek kártyára görget. */
    openInterfaceParameters() {
      this.$router.push({ path: "/parameters", query: { section: "iface-sync" } });
    },

    handleShowRequestTool() {
      this.store.showRequestTool = !this.store.showRequestTool;
    },

    /** Szinkron gomb kattintás — megerősítés, összeállított lekérdezés panel, vagy jelzés, hogy még nincs bekötve. */
    runFeature(button) {
      if (button.confirm) {
        this.handleShowConfirm(button.confirm);
      } else if (button.requestTool) {
        this.handleShowRequestTool();
      } else {
        eventBus.$emit("warn", "Ez a funkció még nincs bekötve.");
      }
    },

    handleShowConfirm(type) {
      this.confirmType = type;
      this.showConfirm = !this.showConfirm;
    },

    /**
     * A megerősítés gomb action handlere — a `confirmType` alapján dönti el a műveletet.
     *  - ReSyncSelectedItems: a két apisearch `selected===true` sorainak id-jait küldi a backendre
     *    az aktuális `selectedInterfaceType`-pal.
     *  - ReSyncInterface: a toolbar `fromDate`/`toDate` dátumait küldi a backendre
     *    az aktuális `selectedInterfaceType`-pal.
     *  - MarkSelectedItemsSkipped: a kijelölt sorokból új köztes tábla sort hoz létre a backend,
     *    `UserModified=true`-val és Skip (5) státusszal. Számlánál fej + tételek is másolódnak.
     *    Nincs külső API hívás.
     *  - SetRemarkOnSelectedItems: a kijelölt sorok `sync_remark` mezőjét írja felül a megadott
     *    szöveggel — új sor nem keletkezik, külső API hívás nincs.
     */
    async sendRequest() {
      const confirmTypesNeedSelection = [
        ConfirmType.ReSyncSelectedItems,
        ConfirmType.MarkSelectedItemsSkipped,
        ConfirmType.SetRemarkOnSelectedItems,
        ConfirmType.UpSyncSelectedItems,
        ConfirmType.UpSyncReloadSelectedItems,
      ];

      if (confirmTypesNeedSelection.includes(this.confirmType) && this.store.selectedItems.length === 0) {
        eventBus.$emit("error", t("Interface_NincsKijeloltTetelAMuvelethez"));
        this.handleShowConfirm(ConfirmType.None);
        return;
      }

      try {
        if (this.confirmType === ConfirmType.ReSyncSelectedItems) {
          await this.store.downSyncSelectedItems();
        } else if (this.confirmType === ConfirmType.ReSyncInterface) {
          await this.store.downSyncInterface();
        } else if (this.confirmType === ConfirmType.MarkSelectedItemsSkipped) {
          await this.store.markSelectedItemsSkipped();
        } else if (this.confirmType === ConfirmType.SetRemarkOnSelectedItems) {
          await this.store.setSyncRemarkOnSelectedItems(this.remarkText);
          this.showRemarkField = false;
          this.remarkText = "";
        } else if (this.confirmType === ConfirmType.UpSyncLoadInterface) {
          //UpSync betöltés: ugyanaz a TF végpont, az IfaceSync API útvonala az (iface, ifaceType) alapján a load végpont
          await this.store.downSyncInterface();
        } else if (this.confirmType === ConfirmType.UpSyncSelectedItems) {
          //UpSync felküldés: ugyanaz a TF végpont, az IfaceSync API útvonala az (iface, ifaceType) alapján a sync végpont
          await this.store.downSyncSelectedItems();
        } else if (this.confirmType === ConfirmType.UpSyncReloadSelectedItems) {
          //UpSync újra betöltés: a kijelölt sorok belső azonosítóival a load végpont, a "custom request" úton
          await this.store.upSyncReloadSelectedItems();
        } else {
          return;
        }

        this.reload();
      } catch (e) {
        console.error(e);
      } finally {
        this.handleShowConfirm(ConfirmType.None);
      }
    },
  },
});
